/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import FormInput from '../../components/FormInput';
import { createAdmin, getAllStates, getAllCities, getAllPincode } from '../../middleware/backend_hepler';
import { Button, Row, Col } from "react-bootstrap";
import SelectInput from "../../components/SelectInput";
import { validationRules } from "../../utils/validationRules";
import DropDownInput from "../../components/DropDownInput";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import employeeProfile from "../../assets/default-profile.png"


const CreateEmployeeForm = () => {
    const [loading, setLoading] = useState(true);
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [pincodenumber, setPincode] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const navigate = useNavigate();
    const [employeeData, setEmployeeData] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);

    const methods = useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });
  
    const {
      handleSubmit,
      setValue,
      formState: { errors, isValid },
      watch,
    } = methods;

    const password = watch('password', '');
    const dob = watch('dob');

    React.useEffect(() => {
      if (dob) {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        if (age >= 0) {
          setValue("age", age);
        } else {
          setValue("age", "");
        }
      }
    }, [dob, setValue]);

    useEffect(() => {
      const fetchStates = async () => {
        try {
          const statesData = await getAllStates();
          const availableStates = statesData.filter(
            (state) => state.availability === "Yes"
          );
          setStates(availableStates);
          setFilteredStates(availableStates);
        } catch (error) {
          console.error("Error fetching states data:", error);
        }
      };
      fetchStates();
    }, []);

    const stateOptions = filteredStates.map((state) => ({
      value: state.name,
      label: state.name,
    }));

    useEffect(() => {
      const fetchCities = async () => {
        try {
          const citiesData = await getAllCities();
          citiesData.sort((a, b) => a.name.localeCompare(b.name));
          setCities(citiesData);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };
      fetchCities();
    }, []);

    useEffect(() => {
      const fetchPinCode = async () => {
        try {
          const pincodeData = await getAllPincode();
          setPincode(pincodeData);
        } catch (error) {
          console.error("Error fetching pincodes:", error);
        }
      };
      fetchPinCode();
    }, []);

    useEffect(() => {
      if (!selectedState) {
        setCityOptions([]);
        setPincodeOptions([]);
        return;
      }

      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];

      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }, [selectedState, cities, pincodenumber]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          formDataToSend.append(key, data[key]);
        }
      });

      if (selectedFile) {
        formDataToSend.append("photo", selectedFile);
      }

      const response = await createAdmin(formDataToSend);
      setLoading(false);
      navigate("/employee-list", {
        state: { successMessage: "Employee created successfully!" },
      });
    } catch (error) {
        setLoading(false);

        const errorMessage =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "";

        if (
          errorMessage.toLowerCase().includes("mobile")
        ) {
          toast.error("Mobile number already exists. Please use a different mobile number.");
        } else if (
          errorMessage.toLowerCase().includes("email")
        ) {
          toast.error("Email already exists. Please use a different email.");
        } else if (
          errorMessage.toLowerCase().includes("already exists")
        ) {
          toast.error("Mobile or Email already exists.");
        } else {
          console.error("Error for employee creation:", error);
          toast.error("Failed to create employee. Please try again.");
        }
    }
  };

  const handleFileChange = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file);
      setEmployeeData({ ...employeeData, photo: URL.createObjectURL(file) });
  };

  const handleViewClick = () => {
      if (employeeData && employeeData.photo) {
        window.open(decodeURIComponent(employeeData.photo), "_blank");
      } else {
        toast.warning("No image available.");
      }
  };

  return (
    <div className="edit-all-loan-container">
      <h2>Employee</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="avatar-container mb-4 text-center">
            {employeeData.photo ? (
              <img
                src={
                  employeeData.photo
                    ? decodeURIComponent(employeeData.photo)
                    : "default-avatar.png"
                }
                onClick={handleViewClick}
                className="avatar-image"
              />
            ) : (
              <img
                src={employeeProfile}
                onClick={handleViewClick}
                className="avatar-image"
                alt="Default Profile"
              />
            )}
          </div>

          <div className="upload-container mb-4 text-center">
            <input
              type="file"
              id="photo"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <Button
              variant="primary"
              onClick={() => document.getElementById("photo").click()}
              className="profile-image"
            >
              Upload Profile
            </Button>
          </div>
          <div className="sections personal-details-sections">
            <h4>Personal Details</h4>
            <Row>
              <Col md={6}>
                <FormInput
                  name="name"
                  label="Name"
                  registerOptions={{ required: "Name is required" }}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  name="dob"
                  label="Date of Birth"
                  type="date"
                  registerOptions={{
                    required: "Date of Birth is required",
                    validate: {
                      isOldEnough: (value) => {
                        const today = new Date();
                        const minAgeDate = new Date();
                        const maxAgeDate = new Date();
                        minAgeDate.setFullYear(today.getFullYear() - 21);
                        maxAgeDate.setFullYear(today.getFullYear() - 58);
                        return (
                          (new Date(value) <= minAgeDate &&
                            new Date(value) >= maxAgeDate) ||
                          "Choose age from 21 to 58"
                        );
                      },
                      isNotFutureDate: (value) => {
                        return (
                          new Date(value) <= new Date() ||
                          "Date of Birth cannot be in the future"
                        );
                      },
                    },
                  }}
                  error={errors.dob?.message}
                />
              </Col>
              <Col md={6}>
                <FormInput name="age" label="Age" type="number" readOnly />
              </Col>
              <Col md={6}>
                <FormInput
                  name="mobile"
                  label="Mobile"
                  type="tel"
                  registerOptions={validationRules.mobile}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  name="email"
                  label="Email ID"
                  registerOptions={validationRules.email}
                />
              </Col>
              <Col md={6}>
                <DropDownInput
                  name="role"
                  label="User Role"
                  options={[
                    { label: "Admin", value: "admin" },
                    { label: "Employee", value: "employee" },
                  ]}
                  registerOptions={{ required: "User Role is required" }}
                  error={errors.role?.message}
                />
              </Col>
              <Col md={6}>
                <DropDownInput
                  name="status"
                  label="Status"
                  options={[
                    { label: "Active", value: "Active" },
                    { label: "Inactive", value: "Inactive" },
                  ]}
                  registerOptions={{ required: "Status is required" }}
                  error={errors.status?.message}
                />
            </Col>
              <Col md={6}>
                <FormInput
                  name="password"
                  label="Password"
                  registerOptions={{
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                  }}
                  error={errors.password?.message}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  name="confirm_password"
                  label="Confirm Password"
                  registerOptions={{
                    required: "Confirm password is required",
                    validate: (value) =>
                      value === password || "Passwords do not match",
                  }}
                  error={errors.confirm_password?.message}
                />
              </Col>
              <Col md={6}>
                <FormInput
                  name="address"
                  label="Address"
                  registerOptions={{ required: "Address is required" }}
                />
              </Col>
              <Col md={6}>
                <SelectInput
                  name="state"
                  label="State"
                  options={stateOptions}
                  value={getSelectedStateValue()}
                  registerOptions={{ required: "State is required" }}
                  onChange={handleStateChange}
                  error={errors.state?.message}
                />
              </Col>
              <Col md={6}>
                <SelectInput
                  name="city"
                  label="City"
                  options={cityOptions}
                  registerOptions={{ required: "City is required" }}
                  error={errors.city?.message}
                />
              </Col>
              <Col md={6}>
                <SelectInput
                  name="pincode"
                  label="Pincode"
                  options={pincodeOptions}
                  registerOptions={{ required: "Pincode is required" }}
                />
              </Col>
            </Row>
          </div>
          <div className="button-container mt-4 text-center">
            <Button
              variant="success"
              type="submit"
              className="custom-submit-button"
            >
              Submit
            </Button>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateEmployeeForm;
